
export enum DocumentFormTypeCd {
	COPY_BILL = 'CopyBill',
	FBDS = 'FBDS'}
